import { render, staticRenderFns } from "./m-medicament.html?vue&type=template&id=7b7a9542&scoped=true&external"
import script from "./m-medicament.js?vue&type=script&lang=js&external"
export * from "./m-medicament.js?vue&type=script&lang=js&external"
import style0 from "./m-medicament.scss?vue&type=style&index=0&id=7b7a9542&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7a9542",
  null
  
)

export default component.exports